import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { timer } from 'rxjs';
import { PosService } from 'src/app/lazy/private/services/pos.service';
import { MainService } from 'src/app/services/main.service';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogService } from '../dialog/dialog.service';

export interface PopUpModel {
  title: string;
  data: any;
}

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent extends DialogComponent<PopUpModel, boolean>
  implements PopUpModel, OnInit {

  title: string;
  data: any;
  result: any = { result: false, RtnItem: {} };
  inputValue = '';
  @ViewChild('num') num: ElementRef;

  constructor(public dialogService: DialogService, private pos: PosService, private ms: MainService) {
    super(dialogService);
  }

  ngOnInit() {
    this.focusto();
  }

  enterOk() {
    const set = this.ms.getSettings();
    const user = {
      Password: this.inputValue,
      LocId: set.LocId
    };
    this.pos.POSCashierId_ByPassword(user).subscribe(res => {
      if (res.Success) {
        this.pos.PosPrivilegeAction_ByActionId({
          UserId: res.data.Id, LocationId: set.LocId,
          ActionId: this.data.ActionId
        }).subscribe(res1 => {
          if (res1.Success && res1.data.UserRight) {
            res1.data['Auth'] = res.data.Id;
            this.result.result = true;
            this.result.RtnItem = res1.data;
            this.close();
          }
        });
      }
    });
  }

  keydown(e) {
    if (e.keyCode === 8 && e.which === 8) {
    } else if (e.keyCode >= 96 && e.keyCode <= 105) {
    } else if (e.keyCode >= 48 && e.keyCode <= 57) {
    } else if (e.keyCode === 110 || e.keyCode === 190) {
      this.keypress(e.key);
    } else if (e.keyCode === 13 && e.which === 13) {
      this.enterOk();
    }
    this.focusto();
  }

  focusto() {
    document.getElementById('num').focus();
  }

  selectAll() {
    const source = timer(200, 1000);
    const sub = source.subscribe(res => {
      const input: any = document.getElementById('num');
      input.focus();
      input.select();
      sub.unsubscribe();
    });
  }

  selection() {
    const input: any = document.getElementById('num');
  }

  keypress(e) {
    this.focusto();
    if (e === '.') {
      if (this.inputValue === '') {
        this.inputValue = '0';
      } else {
        if (this.inputValue.indexOf('.') > -1) {
          return;
        }
      }
    }
    if (e === '<') {
      this.inputValue = this.inputValue.slice(0, -1);
    } else {
      this.inputValue = this.inputValue + e;
    }
  }

}
